module.exports = __webpack_public_path__ + "Flag-440.9bfe7954ce79a14b3535c6d127a4d924.svg";